import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './OffersPage.css';
import Header from '../components/Header';
import Footer from '../components/Footer';

  const fallbackOffers = [
    {
      id: 'offer-monsoon',
      title: 'Monsoon Krishi Dhamaka Offer',
      subtitle: 'Flat 10% OFF + Free Doorstep Delivery',
      description: 'Prepare your fields for the paddy season with our premium Rotavators and Power Weeders. Get special seasonal price cuts and guaranteed direct-to-farm delivery.',
      discountBadge: '10% OFF',
      validity: 'Valid till 31st July 2026',
      badgeClass: 'badge-green',
      icon: '🌧️',
      enquirySubject: 'Monsoon Krishi Dhamaka Offer'
    },
    {
      id: 'offer-combo',
      title: 'Double Harvest Combo Package',
      subtitle: 'Save ₹15,000 on Combo Purchases',
      description: 'Upgrade your entire farming inventory. Purchase any Shaktiman Rotavator along with a KISAN MB Plough or Disc Harrow and receive instant cash discounts directly at checkout.',
      discountBadge: 'Save ₹15,000',
      validity: 'Limited Time Offer',
      badgeClass: 'badge-orange',
      icon: '🌾',
      enquirySubject: 'Double Harvest Combo Package'
    },
    {
      id: 'offer-finance',
      title: 'Zero Downpayment & Subsidy Support',
      subtitle: 'Up to 50% Govt. Subsidy Assistance',
      description: 'Do not let budget stop your progress. Avail 0% downpayment financing options and get full paperwork assistance from our experts to claim state-government subsidies.',
      discountBadge: '0% Downpayment',
      validity: 'Always Active',
      badgeClass: 'badge-blue',
      icon: '🛡️',
      enquirySubject: 'Finance and Subsidy Assistance'
    }
  ];
   const OffersPage = () => {
          const navigate = useNavigate();
          const [offersList, setOffersList] = useState([]);
          const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchOffers = async () => {
      try {
        const isLocalHost = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1' || window.location.hostname.startsWith('192.168.');
        const envApiUrl = process.env.REACT_APP_API_URL?.trim();
        const API_URL = envApiUrl && (isLocalHost || (!envApiUrl.includes("localhost") && !envApiUrl.includes("127.0.0.1"))) ? envApiUrl : '/api';
        const res = await fetch(`${API_URL}/offers`);
        const json = await res.json();
        if (json.success && Array.isArray(json.data) && json.data.length > 0) {
          setOffersList(json.data);
        } else {
          setOffersList(fallbackOffers);
        }
      } catch (err) {
        console.error('Failed to fetch offers:', err);
        setOffersList(fallbackOffers);
      } finally {
        setLoading(false);
      }
    };
    fetchOffers();
  }, []);

  return (
    <div className="offers-page">
      <Header />
      
      <main className="offers-main">
        <div className="container">
          <div style={{ marginBottom: '20px', textAlign: 'left' }}>
            <button 
              onClick={() => navigate(-1)} 
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
                background: 'transparent',
                border: 'none',
                color: '#64748b',
                fontWeight: '600',
                cursor: 'pointer',
                padding: '8px 16px 8px 0',
                fontSize: '15px',
                transition: 'color 0.2s',
                outline: 'none'
              }}
              onMouseEnter={(e) => e.currentTarget.style.color = '#1e293b'}
              onMouseLeave={(e) => e.currentTarget.style.color = '#64748b'}
            >
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                <line x1="19" y1="12" x2="5" y2="12"></line>
                <polyline points="12 19 5 12 12 5"></polyline>
              </svg>
              Back
            </button>
          </div>
          <div className="offers-header">
            <span className="promo-badge">🔥 SPECIAL SCHEMES</span>
            <h1 className="offers-title">Active Offers & Farmer Plans</h1>
            <p className="offers-subtitle">Maximize your savings with our seasonal discount plans and special agricultural subsidy programs</p>
          </div>

          {loading ? (
            <div style={{ display: 'flex', justifyContent: 'center', padding: '60px 0' }}>
              <div className="spinner" style={{ width: '40px', height: '40px', borderTopColor: '#4ba242' }}></div>
            </div>
          ) : (
            <div className="offers-grid">
              {offersList.map((offer) => (
                <div key={offer._id || offer.id} className="offer-card">
                  <div className="offer-badge-wrapper">
                    <span className={`discount-badge ${offer.badgeClass}`}>{offer.discountBadge}</span>
                  </div>
                  <div className="offer-content">
                    <div className="offer-icon-large">{offer.icon}</div>
                    <h2 className="offer-card-title">{offer.title}</h2>
                    <h3 className="offer-card-subtitle">{offer.subtitle}</h3>
                    <p className="offer-card-desc">{offer.description}</p>
                    
                    <div className="offer-meta">
                      <span className="validity-text">📅 {offer.validity}</span>
                    </div>

                    <button 
                      className="btn-claim-offer" 
                      onClick={() => navigate(`/enquire?interest=Offer%20Plan&productName=${encodeURIComponent(offer.enquirySubject || offer.title)}`)}
                    >
                      Claim This Offer
                    </button>
                  </div>
                </div>
              ))}
            </div>
          )}

          <div className="subsidy-info-banner">
            <div className="banner-content">
              <h2>Need Help with Government Subsidies?</h2>
              <p>We provide full billing support, state-wise crop registration documents, and machinery certificates required to claim up to 50% government subsidies on qualifying products.</p>
              <button className="btn-banner-action" onClick={() => navigate('/service')}>Read Subsidy Guide</button>
            </div>
          </div>
        </div>
      </main>

      {/* WhatsApp FAB */}
      <div className="whatsapp-fab" onClick={() => window.open('https://wa.me/919631277264', '_blank')} style={{ cursor: 'pointer' }}>
        <svg viewBox="0 0 24 24" width="32" height="32" fill="white">
          <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.438 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.414 0 .004 5.412 0 12.046c0 2.123.555 4.195 1.608 6.014L0 24l6.117-1.605a11.782 11.782 0 005.925 1.587h.005c6.632 0 12.043-5.414 12.047-12.048a11.821 11.821 0 00-3.526-8.513"/>
        </svg>
      </div>

      <Footer />
    </div>
  );
};

export default OffersPage;


